import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import './styles/LoginPage.css';
import loginImage from '../assets/Logo Kidola PNG.png';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        const success = await login(username, password);
        if (success) {
            navigate('/home');
        } else {
            alert('Login failed');
        }
    };

    return (
        <div className="login-container">
            <div className="login-form">
                <div className="login-form-content">
                    <h2>Login</h2>
                    <form onSubmit={handleLogin}>
                        <div>
                            <label>Username</label>
                            <input
                                type="text"
                                name="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <button type="submit">Login</button>
                    </form>
                </div>
                <img src={loginImage} className="login-form-image" alt="Login Illustration" />
            </div>
        </div>
    );
};

export default LoginPage;
